import * as Yup from "yup";
import {FIELD_STRING} from "../../../../common/constants/validationErrors";

import * as consultationSouscriptionFormNames from "./consultationSouscriptionsFormNames";

export const consultationSouscriptionValidationSchema = Yup.object().shape({
  [consultationSouscriptionFormNames.IDENTIFIANT_SOUSCRIPTION_FORM_NAME]:
    Yup.string().typeError(FIELD_STRING),
  //   [consultationSouscriptionFormNames.CODE_PACKAGE_FORM_NAME]:
  //     Yup.string().typeError(FIELD_STRING),
  //   [consultationSouscriptionFormNames.ROLE_OPERATEUR_FORM_NAME]:
  //     Yup.number().typeError(FIELD_NUMBER),
  //   [consultationSouscriptionFormNames.STATUS_PACKAGE_FORM_NAME]:
  //     Yup.string().typeError(FIELD_STRING),
  //   [consultationSouscriptionFormNames.TYPE_PAIEMENT_FORM_NAME]:
  //     Yup.string().typeError(FIELD_STRING),
  //   [consultationSouscriptionFormNames.TRANSACTION_AUTORISEE_FORM_NAME]:
  //     Yup.string().typeError(FIELD_STRING),
  //   [consultationSouscriptionFormNames.VALIDITE_PACKAGE_FORM_NAME]:
  //     Yup.string().typeError(FIELD_STRING),
});
